<header>
  <img src="cb-logo.svg" />
  <!-- Desktop Nav -->
  <div id="desktop" class="flex gap-20">
    <!-- <app-nav-item label="Nav Item" [selected]="true" [usePopover]="true">Item</app-nav-item>
    <app-nav-item label="Nav Item" /> -->
    <a class="decoration-none cursor-pointer" (click)="applicationListClick()">
      <app-nav-item label="Applications" />
    </a>
    @if (isAdmin) {
      <a class="decoration-none cursor-pointer" (click)="usersClick()">
        <app-nav-item label="Users" />
      </a>
      <a class="decoration-none cursor-pointer" (click)="inviteAdminClick()">
        <app-nav-item label="Invite Admin" />
      </a>
    }
    <div class="header-account-group">
      @if (displayName) {
        <span
          class="header-account-name"
          [attr.title]="accountTooltip || displayName"
        >{{ displayName }}</span>
        <span class="header-account-sep" aria-hidden="true"></span>
      }
      <a class="decoration-none cursor-pointer" (click)="homeClick()">
        <app-nav-item label="Logout" />
      </a>
    </div>
  </div>

  <!-- Mobile Nav -->
  <div id="mobile">
    <div class="hamburger">
      <i class="fa-solid fa-bars size-24" style="color: white" (click)="toggleMenu()"></i>
    </div>

    <div class="mobile-menu" [class.open]="showMenu">
      <nav>
        <a class="decoration-none cursor-pointer" (click)="applicationListClick()">
          <app-nav-item label="Applications" />
        </a>
        @if (isAdmin) {
          <a class="decoration-none cursor-pointer" (click)="usersClick()">
            <app-nav-item label="Users" />
          </a>
          <a class="decoration-none cursor-pointer" (click)="inviteAdminClick()">
            <app-nav-item label="Invite Admin" />
          </a>
        }
        @if (displayName) {
          <div
            class="mobile-signed-in"
            [attr.title]="accountTooltip || displayName"
          >
            <span class="mobile-signed-in-label">Signed in as</span>
            <span class="mobile-signed-in-name">{{ displayName }}</span>
          </div>
        }
        <a class="decoration-none cursor-pointer" (click)="homeClick()">
          <app-nav-item label="Logout" />
        </a>
      </nav>
    </div>
  </div>
</header>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
